// Interest rates are shown with a decimal comma and without trailing zeros: 15,5 rather than 15.50.
export function useRateFormat(rate: number): string {
  return rate.toString().replace('.', ',')
}
